// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestProtocolOperationTemplateId } from './HarvestProtocolOperationTemplate';
import { batchTypeEnum } from './BatchTypeEnum';
import { batchClearanceDefinitionId } from './BatchClearanceDefinition';
import { z } from 'zod';
export const harvestProtocolOpBatchDefinitionId = (z.number());
export const harvestProtocolOpBatchDefinition = z.object({
    id: harvestProtocolOpBatchDefinitionId,
    protocol_op_template_id: harvestProtocolOperationTemplateId,
    name: z.string(),
    description: z.string().nullable(),
    batch_type: batchTypeEnum,
    expected_weight_kg: z.string().nullable(),
    storage_requirements: z.string().nullable(),
    clearance_definition_id: batchClearanceDefinitionId.nullable(),
    shelf_life_days: z.number().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const harvestProtocolOpBatchDefinitionInitializer = z.object({
    id: harvestProtocolOpBatchDefinitionId.optional(),
    protocol_op_template_id: harvestProtocolOperationTemplateId,
    name: z.string(),
    description: z.string().optional().nullable(),
    batch_type: batchTypeEnum,
    expected_weight_kg: z.string().optional().nullable(),
    storage_requirements: z.string().optional().nullable(),
    clearance_definition_id: batchClearanceDefinitionId.optional().nullable(),
    shelf_life_days: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const harvestProtocolOpBatchDefinitionMutator = z.object({
    id: harvestProtocolOpBatchDefinitionId.optional(),
    protocol_op_template_id: harvestProtocolOperationTemplateId.optional(),
    name: z.string().optional(),
    description: z.string().optional().nullable(),
    batch_type: batchTypeEnum.optional(),
    expected_weight_kg: z.string().optional().nullable(),
    storage_requirements: z.string().optional().nullable(),
    clearance_definition_id: batchClearanceDefinitionId.optional().nullable(),
    shelf_life_days: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=HarvestProtocolOpBatchDefinition.js.map